import React from "react";
import styled from "styled-components";
import ColorPopup from "../../Shared/ColorPopup";
import MarginBox from "../../Shared/MarginBox";
import SettingsSlider from "../../Shared/SettingsSlider";
import TextView from "../../../TextView";
import CustomSwitch from "../../../CustomSwitch";
import { ASSETS } from "../../../../utils/config";
import Dropdown from "../../../Dropdown";

const Container = styled.div``;

const GridTypeContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 10px;
  margin-top: 20px;
  margin-bottom: 20px;
`;

const GridTypeItem = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border: ${(props) =>
    props.isSelected ? "2px solid #625B71" : "border: 1px solid  #CAC4D0"};
  border-radius: 4px;
  padding: 10px;
  box-shadow: 0px 0px 9.3px 0px #3b3b3b1c;
  height: 120px;
`;

const GridTypeImage = styled.img`
  width: 40px;
  height: 40px;
  margin-bottom: 10px;
  opacity: ${(props) => (props.isSelected ? 1 : 0.8)};
`;

const GRID_TYPES = {
  STANDARD: "standard",
  QUILTED: "quilted",
  MASONRY: "masonry",
};

const gridTypes = [
  {
    title: GRID_TYPES.STANDARD,
    image: ASSETS.defaultGrid,
  },
  {
    title: GRID_TYPES.QUILTED,
    image: ASSETS.quiltedGrid,
  },
  {
    title: GRID_TYPES.MASONRY,
    image: ASSETS.masonryGrid,
  },
];

const columnsArray = [
  { value: 1, label: "1" },
  { value: 2, label: "2" },
  { value: 3, label: "3" },
  { value: 4, label: "4" },
];
export default function Layout({
  margin,
  isApplyMarginOnAllSides,
  allSideMargin,
  borderRadius,
  borderColor,
  borderWidth,
  dropShadowColor,
  showCaptions,
  gridType,
  handleChange,
  handleAdjustment,
  columns,
}) {
  return (
    <Container>
      <TextView variant="subtitle">Grid Type</TextView>
      <GridTypeContainer>
        {gridTypes.map((type) => (
          <GridTypeItem
            key={type.title}
            isSelected={gridType === type.title}
            onClick={() => handleChange("gridType", type.title)}
          >
            <GridTypeImage
              src={type.image}
              alt={type}
              isSelected={gridType === type.title}
            />
            <TextView style={{ textTransform: "capitalize" }}>
              {type.title}
            </TextView>
          </GridTypeItem>
        ))}
      </GridTypeContainer>

      <TextView variant="subtitle" style={{ marginBottom: 10 }}>
        Show Captions
        <CustomSwitch
          checked={showCaptions}
          onChange={() => handleChange("showCaptions")}
        />
      </TextView>
      <Dropdown
        label={"Columns"}
        labelVariant={"subtitle"}
        variant="outlined"
        options={columnsArray}
        value={columns}
        defaultValue={columns}
        onChange={(e) => handleChange("columns", e.target.value)}
        style={{ marginBottom: 20 }}
      />
      <MarginBox
        margin={margin}
        increaseMargin={(side) => handleAdjustment(side, "increase")}
        decreaseMargin={(side) => handleAdjustment(side, "decrease")}
        isApplyMarginOnAllSides={isApplyMarginOnAllSides}
        allSideMargin={allSideMargin}
        handleMarginCheckBox={() => handleChange("marginCheckbox")}
        handleSliderMarginChange={(value) =>
          handleChange("allSideMargin", value)
        }
        handleMarginChange={(side, value) =>
          handleChange("margin", value, side)
        }
        symbol={"px"}
      />
      <SettingsSlider
        title="Corner Rounding"
        sliderValue={borderRadius}
        onValueChange={(val) => handleChange("border", val)}
        min={0}
        max={20}
      />
      <ColorPopup
        title="Border"
        background={borderColor}
        handleChangeBackgroundColor={(val) => handleChange("borderColor", val)}
        resetBackgroundColor={() => handleChange("resetColor")}
        sliderBoxTitle={"Border Width"}
        sliderValue={borderWidth}
        sliderChange={(val) => handleChange("borderWidth", val)}
        sliderMinValue={0}
        sliderMaxValue={8}
        sliderSymbol={"px"}
        isHideGradient={true}
        showSuggestedColorPalette={true}
        isBorderSlider
      />

      <ColorPopup
        title="Drop Shadow"
        background={dropShadowColor}
        handleChangeBackgroundColor={(val) =>
          handleChange("dropShadowColor", val)
        }
        resetBackgroundColor={() => handleChange("resetShadow")}
        showSlider={false}
        isHideGradient={true}
        showSuggestedColorPalette={true}
      />
    </Container>
  );
}
